import { parse, stringify } from 'qs';

export const parseSearch = <T>(search: string) =>
  parse(search, {
    arrayLimit: Infinity,
    decoder(value, decoder) {
      const keywords: Record<string, false | true | null | undefined> = {
        false: false,
        null: null,
        true: true,
        undefined: undefined,
      };

      if (Object.prototype.hasOwnProperty.call(keywords, value)) {
        return keywords[value];
      }

      try {
        return decoder(value);
      } catch (e) {
        return value;
      }
    },
    ignoreQueryPrefix: true,
    strictNullHandling: true,
  }) as unknown as T;

export const stringifyQuery = (query: Record<string, unknown>): string =>
  stringify(query, {
    addQueryPrefix: true,
    encoder(value, encoder, charset, type) {
      if (
        type === 'value' &&
        typeof value === 'string' &&
        ['null', 'undefined', 'true', 'false'].includes(value)
      ) {
        return `%${value.charCodeAt(0).toString(16)}${value.slice(1)}`;
      }

      return encoder(value, encoder, charset);
    },
    strictNullHandling: true,
  });
